/**
 * getvesselmonitoring2dbayview endpoint
 */
export type ColorPalette = {
	color: string;
	text: string;
	description: string;
	count: number;
}

export type Cell = {
	containerNo?: number | null;
	containerCycleId?: number | null;
	lineOperator?: string | null;
	isoCode?: number;
	portOfDischarge?: any;
	color?: string;
	existed: boolean;
	isReefer: boolean;
	is40Foot: boolean;
	isInForAndAfter: boolean;
	isInBay: boolean
	is45Foot: boolean;
	isHazardous: boolean;
	isEmpty: boolean;
	isHighCube: boolean;
	isBreakBulk: boolean;
	isLoadedWrongPosition:boolean;
	yardPlanningIsObserved:boolean;
	loadedWrongPositionNotMatchedFields:string;
	iMODGClassNumber: string;
	portOfLoad:string;
	cntainerType:string;
	containerSize:string;
	weightLevel:string;
	grossWeight:string;
	cellNo:string;
	temprature:string;
	isTranship:boolean;
	portOfTransitDestinationName:string;
	isOverWeightOnBayRow:boolean;
	totalLoadedWeightOnBayRow:string;
	containerTypeHeight:string;
	sI_ContainerSizeMappingName:string;
	sI_ContainerTypeHeight:string;
	sI_ContainerTypeMappingName:string;
	sI_FullEmptyStatus:string;
	sI_PortOfDischargeMappingName:string;
	sI_PortOfTransitDestinationMappingName:string;
	PortOfTransitDestinationMappingName:string;
	TerminalDestinationMappingName:string;
	PortOfLoadMappingName:string;
	PortOfDischargeMappingName:string;
	portOfLoadMappingName:string;
	sI_TEU:string;
	sI_WeightLevel:string;
	sI_CellNo:string;
	sI_ISOCode:string;
	TerminalDestinationAbr:string;
	vesselProfileStackRowWeight:string
	
};

export type OnDeck = {
	rows: number;
	cols: number;
	cells: Cell[];
}


export type Hold = {
	rows: number;
	cols: number;
	cells: Cell[];
}

export type VesselBay = {
	vesselBayType: number;
	sequense: number;
	vesselProfileHatchId: number;
	bay: string;
	bays:[];
	onDeck: OnDeck;
	hold: Hold;
	orderStatusCount:{};
}

export interface VesselProfileHatchCovers{
	coverName: string,
	startCell: number,
	endCell: number
  }
  
export interface VesselHatche {
	vesselProfileHatchId: number;
	vesselBays: VesselBay[];
	cellsCount:number;
	vesselProfileHatchCovers:VesselProfileHatchCovers[]
}

export interface VesselMonitoringData {
	colorPalettes: ColorPalette[];
	vesselHatches: VesselHatche[];
	vesselMonitoringType:string;
}



export type VesselMonitoringResponse = {
	data: VesselMonitoringData;
	isSuccessful: boolean;
	tag?: string;
	message: Message[];
	errorField?: never;
}


export interface VesselMonitoringContainerDetailData {
	containerNo: string;
	position: string;
	isoCode: string;
	lineOperator: string;
	containerType: string;
	length: string;
	status: string;
	height: string;
	teu: number;
	weight?: any;
	weightGroup?: any;
	portOfLoad: string;
	portOfDischarge: string;
	polTerminal?: any;
	podTerminal?: any;
	destination?: any;
	isHazardous: boolean;
	isOOG: boolean;
	bundle: boolean;
	isReefer: boolean;
	IMODGClassNumber:string;
	SI_ContainerTypeMappingName:string;
}


export interface HandlingQuayEquipmentDetailData{
containerNo: string;
	Code: string;
	ContainerNo: string;
	ContainerSize: string;
	ContainerType: string;
	POT: string;
	POL: string;
	POD: string;
	IsOOG: boolean;
	IsDG: boolean;
	IMODGClassNumber?: any;
	IsFlexi: boolean;
	FullEmptyStatus: string;
	BayNo: string;
	VoyageOperationId: string;
	RowNo: string;
	TierNo: string;
	Status: string;
	OperationDate: string;
}



export interface ErrorField { }

export interface VesselMonitoringContainerDetailRequest {
	containerNo: string;
	voyageId: number;
}

export interface VesselMonitoringContainerDetailResponse {
	data: VesselMonitoringContainerDetailData;
	isSuccessful: boolean;
	tag?: any;
	message: Message[];
	errorField: ErrorField;
}
export interface HandlingQuayEquipmentDetailResponse {
	data: HandlingQuayEquipmentDetailData;
	isSuccessful: boolean;
	tag?: any;
	message: Message[];
	errorField: ErrorField;
}



export enum VesselMonitoringView {
  SingleBay=1,
  MiniOneBayWide=2, //Mini - One bay wide
  MiniAllBays=3 //Mini - All bays
}

export enum VesselMonitoringDeck{
  Both=1,
  Above=2, 
  Below=3
}

export enum VesselMonitoringType {
  Discharge=1,
  Load=2,
  Restow=3,
  Inventory=4
}

export enum VesselMonitoringStatus {
  Plan =1,
  InProgress=2,
  Done=3,
  All=4
}


export type VesselMonitoringRequest = {
  bay?: number;
  colorBy: number;
  deck?: VesselMonitoringDeck;
  status: string;
  type: VesselMonitoringType;
  view: VesselMonitoringView;
  voyageId: number
}

/**
 * ColorBy endpoint
 */

export type ColorBy = {
	id: number;
	name: string;
}

export type ColorByData = {
  colorByList: ColorBy[];
}


export type ColorByResponse = {
	data: ColorByData;
	isSuccessful: boolean;
	tag?: any;
	message: Message[];
	errorField?: any;
}


/**
 * GetVesselMonitoringView endpoint
 */

export type VesselMonitoringViewData= {
	id: number;
	name: string;
}


export type VesselMonitoringViewResponse = {
	data: VesselMonitoringViewData[];
	isSuccessful: boolean;
	tag?: any;
	message: Message[];
	errorField?: any;
}

/**
 * GetBayByVoyageId endpoint
 */

export type Bay = {
	bay: number;
	bayNo: string;
}

export type BayList = Bay[];

export type BayByVoyageIdData = {
	bayList: BayList;
}

export type BayByVoyageIdResponse = {
	data: BayByVoyageIdData;
	isSuccessful: boolean;
	tag?: any;
	message: Message[];
	errorField?: any;
}


/**
 * General
 */
export type Message = {
	messageText: string;
	messageType: number;
}





















